import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { IntegrationConfigAttributes } from '../types/interfaces/integrations';

@Injectable({
  providedIn: 'root',
})
export class IntegrationsService {
  constructor(private http: HttpClient) {}

  getIntegration(id: number): Observable<IntegrationConfigAttributes> {
    return this.http.get<IntegrationConfigAttributes>(
      `${environment.apiHost}/integrations/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  getIntegrations(): Observable<IntegrationConfigAttributes[]> {
    return this.http.get<IntegrationConfigAttributes[]>(
      `${environment.apiHost}/integrations`,
      {
        withCredentials: true,
      }
    );
  }

  createIntegration(
    data: IntegrationConfigAttributes
  ): Observable<IntegrationConfigAttributes> {
    return this.http.post<IntegrationConfigAttributes>(
      `${environment.apiHost}/integrations`,
      data,
      {
        withCredentials: true,
      }
    );
  }

  updateIntegration(
    data: IntegrationConfigAttributes
  ): Observable<IntegrationConfigAttributes> {
    return this.http.put<IntegrationConfigAttributes>(
      `${environment.apiHost}/integrations/${data.id}`,
      data,
      {
        withCredentials: true,
      }
    );
  }

  deleteIntegration(id: number): Observable<IntegrationConfigAttributes> {
    return this.http.delete<IntegrationConfigAttributes>(
      `${environment.apiHost}/integrations/${id}`,
      {
        withCredentials: true,
      }
    );
  }
}
